import React from "react";
import {Link} from "react-router-dom";

const mynavbar = {
  backgroundColor: "#cd0000",
  minHeight: "4rem"
};
const maintitle = {
  fontFamily: "Rowdies",
  color: "white",
  fontSize: "xx-large"
};
const mainav = {
  margin: "0px",
  padding: "0px"
};
const naveles = {
  fontFamily: "Rowdies",
  color: "white"
};
const naveles2 = {
  color: "white",
  fontSize: "larger"
};

const Navbar = () => {
  return (
    <div>
      <nav style={mainav} className="navbar fixed-top navbar-expand-lg bg-body-tertiary">
        <div style={mynavbar} className="container-fluid">
          <Link style={maintitle} className="navbar-brand" to="/">
            PepperChronicles
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div style={naveles} className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link style={naveles2} className="nav-link active" aria-current="page" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link style={naveles2} className="nav-link" to="/Science">
                  Science
                </Link>
              </li>
              <li className="nav-item">
                <Link style={naveles2} className="nav-link" to="/Entertainment">
                  Entertainment
                </Link>
              </li>
              <li className="nav-item">
                <Link style={naveles2} className="nav-link" to="/Sports">
                  Sports
                </Link>
              </li>
              <li className="nav-item">
                <Link style={naveles2} className="nav-link" to="/Business">
                  Business
                </Link>
              </li>
              <li className="nav-item">
                <Link style={naveles2} className="nav-link" to="/Technology">
                  Technology
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
